import {
  PushNotifications,
  PushNotificationSchema,
  Token,
  ActionPerformed,
} from "@capacitor/push-notifications";

import { isPlatform } from "@ionic/react";
import firebase from "../fire-base";
import { apiService } from "./apiService";
import { apiServiceConstants, CONSTANTS } from "../constants";
import { utilService } from ".";
import { BehaviorSubject } from "rxjs";
import { NotificationsService } from "../pages/Notifications/NotificationsService";
import { SmartAudioService } from "./SmartAudioService";
import { Device } from "@ionic-native/device";
import { dataTransferService } from "./dataTransferService";
import { scheduleListService } from "../components/Shared/SelectSchedule/SelectSchedule.service";
import { Capacitor } from "@capacitor/core";
import { isOfflineDeployment } from "./telephonyConfig";

// const { PushNotifications } = Plugins;
let firebaseParams = new BehaviorSubject({});
let notificationPayload: any = {};
let notificationData: any = {};
let messaging: any;
let showCareTeamAlert = new BehaviorSubject(false);
let device = Device;
let notificationClicked = new BehaviorSubject(false);

const getToken = () => {
  // FCM registration talks to fcmregistrations.googleapis.com and
  // firebaseinstallations.googleapis.com. There is no route to either from an
  // air-gapped network, and push could not be delivered there in any case --
  // it is Google's network, not something that can be self-hosted. Offline,
  // notifications arrive over the WebSocket instead; see
  // aipex-baseapp/deploy/RUNBOOK.md.
  if (isOfflineDeployment()) {
    return;
  }

  let platform: any;

  // if (isPlatform("ios")) {
  //   registerToGetPushNotification();
  // } else if (isPlatform("android")) {
  //   registerToGetPushNotification();
  // } else if (!isPlatform("capacitor")) {
    platform = "web";
    let messaging: any;
    if (firebase.messaging.isSupported()) {
      console.log("test qq messagge supported")
      messaging = firebase.messaging();
      messaging
        .requestPermission()
        .then(() => {
          messaging
            .getToken()
            .then((currentToken: any) => {
              // Displays the current token data
              const params = getParamsForNewSubscription(platform, currentToken);
              saveTokenApiCall(params);
            })
            .catch((err: any) => {});
        })
        .catch((err: any) => {});
    }
  // }
};

const registerToGetPushNotification = () => {
  const isPushNotificationsAvailable = Capacitor.isPluginAvailable(
    "PushNotifications"
  );
  // if (isPushNotificationsAvailable) {
  //   // Register with Apple / Google to receive push via APNS/FCM
  //   PushNotifications.register();
  // }
  if (isPushNotificationsAvailable) {
  PushNotifications.requestPermissions().then((permission: any) => {
    if (permission.granted) {
      // Register with Apple / Google to receive push via APNS/FCM
      PushNotifications.register();
    } else {
      // No permission for push granted
      PushNotifications.register();
    }
  });

  // On success, we should be able to receive notifications
  PushNotifications.addListener("registration", (token: Token) => {
    const platform = isPlatform("android") ? "android" : "ios";
    const deviceId = device.uuid;
    const deviceName = device.model;
    const params = getParamsForNewSubscription(
      platform,
      token.value,
      deviceId,
      deviceName
    );
    saveTokenApiCall(params);
  });

  // Some issue with your setup and push will not work
  PushNotifications.addListener("registrationError", (error: any) => {});

  // Show us the notification payload if the app is open on our device
  PushNotifications.addListener(
    "pushNotificationReceived",
    (notification: PushNotificationSchema) => {
      console.log("push received");
      notificationPayload["guid"] = notification?.data.guid
        ? notification.data.guid
        : "";
      notificationPayload["request_type"] = notification?.data?.request_type
        ? notification.data?.request_type
        : -1;
      notificationData = notification;
      setTimeout(() => {
        getNotificationCount();
        calenderUpdate();
      }, 300);
      openAlertPopup();
    }
  );

  // Method called when tapping on a notification
  PushNotifications.addListener(
    "pushNotificationActionPerformed",
    (notification: ActionPerformed) => {
      notificationClicked.next(true);
    }
  );
}
};

const getParamsForNewSubscription = (
  platform: any,
  token: any,
  deviceId = "",
  name = ""
) => {
  const guid = utilService.getLoggedUserGuid();
  return {
    name: name,
    guid: guid,
    type: platform,
    registration_id: token,
    device: deviceId,
    reg_code: utilService.getNetwork(),
  };
};

const saveTokenApiCall = async (params: any) => {
  const result = await saveToken(params);
  if (result) {
    setFirebaseToken(params);
  }
};

const setFirebaseToken = (params: any) => {
  firebaseParams.next(params);
};

const saveToken = async (params: any) => {
  const respApiResult = await apiService
    .apiCall(
      `user/push-notifications/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });

  return respApiResult;
};

/**
 * Ends the session on the server.
 *
 * Despite the name this is what revokes the user's API token: the endpoint
 * deletes the FCM device *and* the DRF token, and DRF tokens never expire on
 * their own. It used to run inside
 * `firebaseParams.asObservable().subscribe(...)` with an `isEmpty` guard, so it
 * only fired when push registration had succeeded. On any desktop browser
 * where notifications were unsupported or not granted, firebaseParams stayed
 * `{}`, no request was sent, and "sign off" only cleared local storage -- the
 * token stayed valid for anyone who had captured it. (The subscription was also
 * never unsubscribed.)
 *
 * It is awaited now, and sends the request whether or not a device was
 * registered, falling back to the stored guid.
 */
const deleteToken = async () => {
  const params: any = firebaseParams.getValue() || {};
  const guid = params.guid || utilService.getLoggedUserGuid();

  if (!guid) {
    return;
  }

  return apiService
    .apiCall(
      `user/push-notifications/${guid}/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.DELETE,
      utilService.getDeviceType()
    )
    .catch((err) => {
      // Sign-out must not be blocked by a failed revoke; local state is
      // cleared either way.
      console.error("Failed to revoke the session on the server:", err);
    });
};

const registerWebServiceWorkerOnPageReload = () => {
  // The service worker importScripts() the Firebase SDK from gstatic.com, so
  // with no internet it fails to install on every single page load. index.html
  // already skips its own registration offline; this is the second registration
  // path, from JS, and needs the same guard.
  if (isOfflineDeployment()) {
    return;
  }

  if (!isPlatform("capacitor")) {
    if (firebase.messaging.isSupported()) {
      messaging = firebase.messaging();

      // Register the SW first so it installs/activates.
      navigator.serviceWorker.register("firebase-messaging-sw.js").catch((err: any) => {
        console.error("Service worker registration failed:", err);
      });

      // ── BACKUP CHANNEL ──────────────────────────────────────────────────────
      // The SW will postMessage every push directly to all window clients.
      // This fires independently of Firebase SDK's onMessage, so it works even
      // when onMessage stops after the first notification.
      navigator.serviceWorker.addEventListener("message", (event: MessageEvent) => {
        if (event.data && event.data.type === "FCM_PUSH_RECEIVED") {
          try {
            notificationData = event.data.payload || {};
            notificationPayload = event.data.payload?.data || {};
            setTimeout(() => {
              getNotificationCount();
              calenderUpdate();
            }, 300);
            openAlertPopup();
          } catch (err) {
            console.error("test push error in SW message handler:", err);
          }
        }
      });
      // ────────────────────────────────────────────────────────────────────────

      navigator.serviceWorker.ready
        .then((registration) => {
          messaging.useServiceWorker(registration);

          // Primary channel: Firebase SDK onMessage (foreground only).
          messaging.onMessage((payload: any) => {
            try {
              notificationData = payload ? payload : {};
              notificationPayload = payload?.data ? payload.data : {};
              setTimeout(() => {
                getNotificationCount();
                calenderUpdate();
              }, 300);
              openAlertPopup();
            } catch (err) {
              console.error("test push [onMessage] ERROR:", err);
            }
          });
        })
        .catch((err: any) => {
          console.error("Service worker ready failed:", err);
        });
    }
  }
};

const getNotificationCount = async () => {
  const params = {
    guid: utilService.getLoggedUserGuid(),
  };
  if (params.guid) {
    const resp = await NotificationsService.getNotificationCount(params);
    if (resp.isSuccess) {
      NotificationsService.unReadNotificationCount(resp);
    }
  }
};

const calenderUpdate = () => {
  console.log("calenderUpdate called! Data being transferred:", scheduleListService.selectedScheduleData);
  dataTransferService.transferToGetSchedules(
    scheduleListService.selectedScheduleData
  );
};

const openAlertPopup = () => {
  if (
    Number(notificationPayload?.request_type) ==
    CONSTANTS.REQUEST_TYPE.EMERGENCY
  ) {
    careTeamAlert();
  }
};

const makeRandom = (lengthOfCode: number, possible: string) => {
  let text = "";
  for (let i = 0; i < lengthOfCode; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
};

const careTeamAlert = () => {
  const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890,./;'[]=-)(*&^%$#@!~`";
  const lengthOfCode = 15;
  const audioTrack = makeRandom(lengthOfCode, possible);
  SmartAudioService.currentAudioTrack = audioTrack;
  SmartAudioService.preload(audioTrack);
  showCareTeamAlert.next(notificationData);
};

export const pushNotificationService = {
  getToken,
  registerWebServiceWorkerOnPageReload,
  deleteToken,
  showCareTeamAlert,
  careTeamAlert,
  notificationClicked,
};
